import { createSlice } from "@reduxjs/toolkit";

export const productSlice = createSlice({
  name: "product",
  initialState: {
    addedfilter: [],
    quickshipvalue: "",
    sortbyvalue: "",
    productcount: 0,
    listcategory: "",
    pagecount: 1,
    categorydetails: [],
    caratfilter: [],
    productlist: [],
    totalcount: 0,
    currentproductdata: [],
    pricefilter: [],
    pageInfo: {},
    detailSlug: "",
    isPurchased: false,
    promotionProducts: [],
    promostionCount: 40,
    addOffset: 0,
  },
  reducers: {
    isPurchased: (state, action) => {
      state.isPurchased = action.payload;
    },
    detailSlug: (state, action) => {
      state.detailSlug = action.payload;
    },
    caratfilter: (state, action) => {
      state.caratfilter = action.payload;
    },
    pricefilter: (state, action) => {
      state.pricefilter = action.payload;
    },
    addfilter: (state, action) => {
      state.addedfilter = action.payload;
    },
    quickship: (state, action) => {
      state.quickshipvalue = action.payload;
    },
    sortby: (state, action) => {
      state.sortbyvalue = action.payload;
    },
    productcount: (state, action) => {
      state.productcount = action.payload;
    },
    listcategory: (state, action) => {
      if (state.listcategory != action.payload) {
        state.productlist = [];
        state.pagecount = 1;
        state.productcount = 0;
      }
      state.listcategory = action.payload;
    },
    page: (state, action) => {
      state.pagecount = action.payload;
    },
    totalcount: (state, action) => {
      state.totalcount = action.payload;
    },
    categorydetails: (state, action) => {
      state.categorydetails = action.payload;
    },
    productlistdata: (state, action) => {
      state.productlist = action.payload;
    },
    currentproductdata: (state, action) => {
      state.currentproductdata = action.payload;
    },
    pageDetails: (state, action) => {
      state.pageInfo = action.payload;
    },
    promotionProducts: (state, action) => {
      state.promotionProducts = action.payload;
    },
    promostionCount: (state, action) => {
      state.promostionCount = action.payload;
    },
    addOffset: (state, action) => {
      state.addOffset = action.payload;
    },
  },
});
export const {
  addfilter,
  sortby,
  quickship,
  productcount,
  listcategory,
  page,
  categorydetails,
  caratfilter,
  productlistdata,
  totalcount,
  currentproductdata,
  promotionProducts,
  pricefilter,
  pageDetails,
  detailSlug,
  isPurchased,
  promostionCount,
  addOffset
} = productSlice.actions;
export default productSlice.reducer;
